import React from "react";
import PageWrapper from "./Rewards.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import RewardsViewDetails from "components/Rewards/RewardsViewDetails";

const Rewards = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.rewards"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.rewards"
          }
        ]}
      />
      <div className="user-tbl">
        <RewardsViewDetails {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.permissionReducer,
    ...state.themeChanger,
    ...state.auth
  };
};

export default connect(mapStateToProps, null)(Rewards);
